export default __webpack_public_path__ + "static/media/4D.826c082d.webp";